const openModalFastShop = (id) => {
  updateProgressBar(id, 'clear')
  resetPriceBand();
  clearFastshopResume();
  const modalElement = document.getElementById(`modal--${id}`)
  modalElement.classList.add('visible-modal')
  document.body.classList.add('no-scroll');
}
let disabledFastShopButtons = false;
function handleScrollSectionIntoView(id, sectionId) {
  const element = document.getElementById(`productSelectSection--${Number(id) + 1}--${sectionId}`);
  if (element != null) {
    element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  }else {
    const giftsSection = document.getElementById(`fastShopGifts--${sectionId}`);
    if (giftsSection != null) {
      giftsSection.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
    }
  } 
}
let selectedProductsAmount = 0;

function closeModal(id) {
  const itensMaxQuantity = document.getElementById(`itensMaxQuantity--${id}`);
  const currentVisibleModal = document.getElementById('modal--' + id)
  const goCheckoutBtn = document.getElementById('goCheckoutBtn--' + id);

  disabledFastShopButtons = false;
  updateProgressBar(id, 'clear')
  resetPriceBand();
  resetResumeList()
  currentVisibleModal.classList.remove('visible-modal')
  document.body.classList.remove('no-scroll');
  resetSelectedCounter();
  validateAllPack(id, itensMaxQuantity.value, 'plus')

  if (goCheckoutBtn != null) {
    goCheckoutBtn.disabled = false;
    goCheckoutBtn.classList.remove('.not-clickable');
    goCheckoutBtn.innerHTML = `
      <div>
        Adicionar ao carrinho
    </div>
    `
  }
}

function formatCurrency(value) {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });
  return formatter.format(value / 100);
}

function updateProgressBar(sectionId , operationType) {
  const selectedItems = document.getElementById(`selectedItems--${sectionId}`);
  if(selectedItems == null) return;
  const maxCount = document.getElementById(`itensMaxQuantity--${sectionId}`);
    switch(operationType){
      case 'plus':
        selectedProductsAmount += 1
        break
      case 'minus':
        selectedProductsAmount -= 1
        break
      case 'clear':
        selectedProductsAmount = 0;
        break;
    }
  selectedItems.innerHTML = selectedProductsAmount;
  const percentage = (selectedProductsAmount / Number(maxCount.value)) * 100;
  const barFill = document.querySelector(`.progress-bar-fill--${sectionId}`);
  percentage === 100 ? setTimeout(() => { barFill.style.background = '#82C91E' }, 500) : barFill.style.background = '';
  barFill.style.width = `${percentage != 0 ? percentage : 1}%`;
}
function handleSubtotalSetter(operationType, price, quantityMultiplier, sectionId, maxGlobalQtd) {
  const unlockedGifts = document.querySelectorAll(`.fast-shop-gift--${sectionId}`);
  const currentSubtotalElement = document.querySelector('.order-subtotal--' + sectionId);
  if (currentSubtotalElement != null) {
    const currentSubtotal = currentSubtotalElement.innerHTML
      .split('R$&nbsp;')[1]
      .split(',')
      .join('')
      .split('.')
      .join('');
    let newValue = 0;
    if (operationType === 'plus') {
      newValue = Number(currentSubtotal) + Number(price) * quantityMultiplier;
    } else if (currentSubtotal > 0) {
      newValue = Number(currentSubtotal) - Number(price) * quantityMultiplier;
    }
    validateGiftsUnlock(newValue, unlockedGifts, sectionId);
    currentSubtotalElement.innerHTML = formatCurrency(newValue);
    publish(PUB_SUB_EVENTS.fastshopUpdate, { source: 'fastshop', data: { sectionId } })
    verifyShowUpsellPromo(newValue);
  }
  updateProgressBar(sectionId, operationType);
  handleGlobalQuantitySetter(sectionId, maxGlobalQtd, operationType);
}
function validateGiftsUnlock(currentSubtotal, unlockedGifts, sectionId) {
  const unlockedGiftsText = document.getElementById(`unlockedGiftsText--${sectionId}`);

  unlockedGifts.forEach(gift => {
    const value = Number(gift.querySelector(`#giftValue--${sectionId}`).value) * 100;
    const giftName = gift.querySelector(`#giftName--${sectionId}`).value;
    if (currentSubtotal >= value) {
      gift.style.backgroundColor = '#E9FAC8';
      gift.querySelector('#unlockedGiftTag--' + giftName).classList.remove('hidden-block');
      gift.querySelector('#lockedGiftTag--' + giftName).classList.add('hidden-block');
      gift.querySelector('#unlockedGiftLock--' + giftName).classList.remove('hidden-block');
      gift.querySelector('#lockedGiftLock--' + giftName).classList.add('hidden-block');
      gift.querySelector('#giftLockContainer--' + giftName).style.backgroundColor = '#82C91E';
    } else {
      gift.style.backgroundColor = '#F1F3F5';
      gift.querySelector('#lockedGiftTag--' + giftName).classList.remove('hidden-block');
      gift.querySelector('#unlockedGiftTag--' + giftName).classList.add('hidden-block');
      gift.querySelector('#lockedGiftLock--' + giftName).classList.remove('hidden-block');
      gift.querySelector('#unlockedGiftLock--' + giftName).classList.add('hidden-block');
      gift.querySelector('#giftLockContainer--' + giftName).style.backgroundColor = '#868E96';
    }
  });
  const allGiftsUnlocked = Array.from(unlockedGifts).every(gift => {
    const value = Number(gift.querySelector(`#giftValue--${sectionId}`).value.replace('.', '').replace(',', '')) * 10;
    return currentSubtotal >= value;
  });
  if (allGiftsUnlocked) {
    unlockedGiftsText?.classList?.remove('hidden-block');
  } else {
    unlockedGiftsText?.classList?.add('hidden-block');
  }
}
async function handleGlobalQuantitySetter(sectionId, maxGlobalQtd, operationType) {
  await setTimeout(() => {
    const allProductsQtd = document.querySelectorAll('.input-product-qtd--' + sectionId);
    const qtdCircle = document.querySelector('.qtd-circle--' + sectionId);
    let globalQuantity = 0;
    if (allProductsQtd != null) {
      allProductsQtd.forEach((element) => {
        const variantId = element.name.split('_')[1];
        const quantityMultiplier = document.querySelector(`.quantity_multiplier_${variantId}`).value

        globalQuantity += Number(element.value) * Number(quantityMultiplier);
      });
    }
    if (qtdCircle != null) {
      qtdCircle.innerHTML = globalQuantity;
    }
  }, 100);
  validateAllPack(sectionId, maxGlobalQtd, operationType)
}

async function handleMountAndGoCheckout(sectionId, maxGlobalQtd, goCheckout = false) {
  if (validateAllPack(sectionId, maxGlobalQtd, 'plus')) {
    const cart = document.querySelector('cart-drawer');
    const productArray = { items: [] };
    const allProductsQtd = document.querySelectorAll('.input-product-qtd--' + sectionId);
    if (allProductsQtd != null && allProductsQtd.length) {
      allProductsQtd.forEach((element) => {
        if (element.value > 0) {
          const variantId = element.name.split('_')[1];
          const quantityMultiplier = document.querySelector(`.quantity_multiplier_${variantId}`).value
          const currentQuantity = element.value * Number(quantityMultiplier);
          productArray.items.push({ id: variantId, quantity: currentQuantity });
        }
      });
    }

    const goCheckoutBtn = document.getElementById('goCheckoutBtn--' + sectionId);

    if (goCheckoutBtn != null) {
      goCheckoutBtn.disabled = true;
      goCheckoutBtn.classList.add('.not-clickable');
      goCheckoutBtn.innerHTML = `
       <div class="loading-dots">
        <span class="loading-dot"></span>
        <span class="loading-dot"></span>
        <span class="loading-dot"></span>
      </div>
      `
    }
    if(goCheckout){
      await clearCart();
      await addToCartPack(productArray);
    }else {
      let cartBody;
      cartBody = await addCartItemsInBulk(productArray.items);

      closeModal(sectionId);
      cart.open();
      updateCartDrawer(cartBody);
    }
  } else {
    const packContainer = document.querySelector('.campaign-packs')
    scrollToElementWithOffset(packContainer, -120);
  }
}

async function addToCartPack(items) {
  const url = 'https://www.caffeinearmy.com.br/cart/add.js';

  await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(items),
  }).then(response => {
    setTimeout(() => window.location.href = '/checkout', 4000)
  }).catch((error) => {
    if (goCheckoutBtn != null) {
      goCheckoutBtn.disabled = false;
      goCheckoutBtn.classList.remove('.not-clickable');
      goCheckoutBtn.innerHTML = "Ocorreu um erro ao atualizar o carrinho";
    }
    console.error('Error:', error);
  });
}
async function addCartItemsInBulk(items) {
  const cart = document.querySelector('cart-drawer');
  let sections = [];
  try {
    if (cart && typeof cart.getSectionsToRender === 'function') {
      sections = cart.getSectionsToRender().map(section => section.id);
    };
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items,
        sections,
        sections_url: window.location.pathname
      })
    });

    const result = await response.json();
    return { ...result, items }
  } catch (error) {
    console.error('Erro ao sincronizar item do carrinho:', error);
  }
}


function validateProductBlock(sectionId, maxQtd, operationType) {
  const quantityInputs = document.querySelectorAll(`#quantity--${sectionId}`)
  const quantityMultiplier = document.getElementById(`quantity_multiplier--${sectionId}`)
  const blockImages = document.querySelectorAll(`.product-item-card--${sectionId}`)
  let blockCount = 0;
  if (quantityInputs != null && quantityInputs.length > 0 && !disabledFastShopButtons) {
    quantityInputs.forEach(element => {
      blockCount += Number(element.value);
    })
  }
  if (operationType == 'plus' && blockCount >= maxQtd - 1) {
    asyncValidateProductBlock(blockImages);
  } else {
    blockImages.forEach(element => element.classList.remove('grayscale-disabled'));
  }
  if(disabledFastShopButtons)return
  return blockCount < maxQtd;
}

function asyncValidateProductBlock(blockImages) {
  setTimeout(() => {
    blockImages.forEach(element => {
      const innerDivInput = element.querySelector('.card-info .quantity-box input')
      if (innerDivInput && innerDivInput.value > 0) {
        element.classList.remove('grayscale-disabled')
      } else {
        element.classList.add('grayscale-disabled')
      }
    });
  }, 100);
}

function validateAllPack(sectionId, maxQtdGlobal, operationType) {
  const globalQuantity = document.querySelector('.qtd-circle--' + sectionId);
  const globalMaxQuantity = maxQtdGlobal
  const buttonDisabled = document.querySelector('.buttonCheckout--' + sectionId);
  if ((globalQuantity.innerHTML >= globalMaxQuantity - 1 && operationType == 'plus') || (globalMaxQuantity >= 999 && globalQuantity.innerHTML >= 0  && operationType == 'plus')) {
    buttonDisabled.classList.remove('disabledForced')
  } else if (globalQuantity.innerHTML <= globalMaxQuantity) {
    buttonDisabled.classList.add('disabledForced')
  }

  return globalMaxQuantity >= 999 || globalQuantity.innerHTML >= globalMaxQuantity;
}

function resetSelectedCounter() {
  const productCards = document.querySelectorAll('.product-item-card');
  const subtotals = document.querySelectorAll('#order-subtotal');
  const qtdCircles = document.querySelectorAll('.qtd-circle');
  if (productCards != null && subtotals != null && qtdCircles != null) {
    subtotals.forEach(subtotal => subtotal.innerHTML = 'R$&nbsp;0,00');
    qtdCircles.forEach(qtdCircle => qtdCircle.innerHTML = 0);
    productCards.forEach(card => {
      card.classList.remove('grayscale-disabled');
      card.dispatchEvent(new CustomEvent('reset-count'));
    });
  }
}

function scrollToElementWithOffset(element, offset) {

  element.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
  const offsetPosition = elementPosition + offset;

  setTimeout(() => {
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }, 400);
}

function resetResumeList() {
  const fastShopResumeListElements = document.querySelectorAll(`.fastshop-resume-list`);
  fastShopResumeListElements.forEach(element => element.innerHTML = '');
}

function toggleResumeVisibility(id) {
  const clearFastShopItensButton = document.getElementById('clearFastShopItensButton')
  const resumeSection = document.querySelector(`.fastshop-resume-section--${id}`);
  const buttonsResumeSpan = document.querySelectorAll(`.button-toggle--${id} span`);
  const fastShopResumeListElement = document.getElementById(`fastshop-resume--${id}`);
  const seeMoreChevron =  document.getElementById(`see-more-chevron--${id}`);
  if(seeMoreChevron != null){
    seeMoreChevron.classList.toggle('rotate-180');
  }
  if (fastShopResumeListElement != null && buttonsResumeSpan != null) {
    fastShopResumeListElement.classList.toggle('hidden')
    buttonsResumeSpan.forEach(element => element.classList.toggle('hidden'))
    resumeSection.classList.toggle('items-start')
    clearFastShopItensButton.toggle('hidden')
  }
  calculateAndSetPaddingBottom(id)
}

function mountFastshopResume(id) {
  setTimeout(() => {
    const resumeSection = document.querySelector(`.fastshop-resume-section--${id}`);
    const productList = fastshopResume.getCurrentProductList();
    const fastShopResumeListElement = document.getElementById(`fastshop-resume--${id}`);
    fastShopResumeListElement.innerHTML = '';
    if (productList != null && productList.length != 0) {
      resumeSection.classList.remove('hidden');
        // Group products by id and count quantities
      const productMap = new Map();
      productList.forEach(item => {
        const key = item.id || item.variantId || item.title; // Use a unique identifier
        if (!productMap.has(key)) {
          productMap.set(key, { ...item, quantity: 1 });
        } else {
          productMap.get(key).quantity += 1;
        }
      });

      // Render grouped products
      productMap.forEach(item => {
        const priceFormated = formatCurrency(item.price);
        fastShopResumeListElement.innerHTML += `
        <li class="fastshop-product-item">
          <span>${item.title}</span>
          <span data-fullprice='${item.price}' id="fastShopListItemPrice">${item.quantity}x ${priceFormated}</span>
        </li>
        `
      });
    } else if (productList.length === 0) {
      resumeSection.classList.add('hidden');
    }
  }, 500)
}

function setProductImage(id) {
  const lastProductOnList = fastshopResume.getCurrentProductList().at(-1);
  const iconProduct = document.getElementById(`icon-product--${id}`)
  if (iconProduct != null && lastProductOnList != null) {
    iconProduct.src = lastProductOnList.images[0]
  }
}

function handleFastshopResumeVisuals(id) {
  mountFastshopResume(id)
  setProductImage(id)
}

function calculateAndSetPaddingBottom(id) {
  const productContainer = document.querySelector(`.product-container--${id}`);
  const fixedBottomBar = document.querySelector(`.fixed-bottom-bar--${id}`)
  const paddingOffset = fixedBottomBar.offsetHeight + 15
  if (productContainer != null && fixedBottomBar != null) {
    productContainer.style.paddingBottom = `${paddingOffset}px`;
  }
}

function goToUpsell() {
  const upsellFastShop = document.getElementById('upsell-binded');
  upsellFastShop.classList.remove('hidden');
  scrollToElementWithOffset(upsellFastShop, -50);
}

function verifyShowUpsellPromo(moneyInCents) {
  const upsellFastShop = document.querySelector('.fastshop-upsell-card');
  if (moneyInCents >= 27000 && upsellFastShop != null) {
    upsellFastShop.classList.remove('hidden');
  }
}

function clearFastShopItens(id){
  updateProgressBar(id, 'clear')
  resetPriceBand();
  resetResumeList();
  clearFastshopResume();
  document.querySelectorAll('#order-total').forEach(el => el.textContent = 'R$\u00A00,00');
  document.querySelectorAll('#order-total-discount').forEach(el => el.textContent = 'R$\u00A00,00');
  resetSelectedCounter();
  document.querySelectorAll('.order-discount-pix').forEach((orderDiscountElement) => {
    orderDiscountElement.classList.add('hidden-block');
  });
}

function validateAllProductSelections(containerId, maxQuantity){
  const containerElement = document.querySelector(`.product-container--${containerId}`);
  const productSelectionSections = containerElement?.querySelectorAll('.product-section-block');
  let totalCount = 0;
  productSelectionSections?.forEach(section => {
    const sectionId = section.querySelector('.product-section-id').value
    const quantityInputs = document.querySelectorAll(`#quantity--${sectionId}`)
    if (quantityInputs != null && quantityInputs.length > 0) {
      quantityInputs.forEach(element => {
        totalCount += Number(element.value);
      })
    }
  });
  if(totalCount >= maxQuantity){
    disabledFastShopButtons = true;
    productSelectionSections?.forEach(section => {
      const sectionId = section.querySelector('.product-section-id').value
      const blockImages = document.querySelectorAll(`.product-item-card--${sectionId}`)
      blockImages.forEach(element => {
        const elementAlpineData = Alpine.$data(element);
        if(elementAlpineData.count > 0) {
          return;
        }
        element.classList.add('global-grayscale-disabled')
      });
    });
  }
  else{
    disabledFastShopButtons = false;
    productSelectionSections?.forEach(section => {
      const sectionId = section.querySelector('.product-section-id').value
      const blockImages = document.querySelectorAll(`.product-item-card--${sectionId}`)
      blockImages.forEach(element => {
        element.classList.remove('global-grayscale-disabled')
      });
    });
  }
}